export const EVENT_REMOVE_ALL_KI_FILTER = 'remove-all-ki-filter';
